import styled, { css } from "styled-components";

interface IProps {
    marginTop?: number;
    withShadow?: boolean;
};

export default styled.div<IProps>`
    margin: 0 auto;
    box-sizing: border-box;
    margin-top: ${p => p.marginTop || 0}px;
    ${p =>
        p.withShadow
            ? css`
                  box-shadow: 1px 0 12px 4px rgba(0, 0, 0, 0.2);
              `
            : undefined}
    ${p =>
        p.theme.xs(css`
            width: 100%;
        `)}
    ${p =>
        p.theme.sm.only(css`
            width: ${p.theme.$screenSm - 15}px;
        `)}
    ${p =>
        p.theme.md.only(css`
            width: ${p.theme.$screenMd - 15}px;
        `)}
    ${p =>
        p.theme.lg(css`
            width: ${p.theme.$screenLg - 15}px;
        `)}
`;
